import Image from 'next/image';
import Link from 'next/link';
import { useIntl } from 'react-intl';

import { Icon } from '@/components/Icon';
import { Category } from '@/types';

interface CategoriesListProps {
  categories: Category[];
}

export const CategoriesList = ({ categories = [] }: CategoriesListProps) => {
  const { formatMessage } = useIntl();

  return (
    <div className="px-5">
      <ul className="w-full flex flex-col flex-wrap lg:flex-row">
        {categories?.map(({ categoryLabel, categoryQuery, internalPictureURL }) => {
          const backgroundHexColor = `#${internalPictureURL?.split('?bg=').pop() || '72767E'}`;
          return (
            <li className="w-full lg:w-1/3" key={categoryQuery}>
              <Link
                href={`/categories/${categoryQuery}`}
                key={`home-cover_${categoryQuery}`}
                className="flex flex-row w-full my-4 items-center"
                aria-label={formatMessage(
                  { id: 'categoriesScreen.accessibility.button.category' },
                  { category: categoryLabel }
                )}
              >
                <Image
                  src={internalPictureURL}
                  alt={categoryLabel}
                  className="rounded-md"
                  width={48}
                  height={48}
                  style={{ backgroundColor: backgroundHexColor }}
                />
                <p className="ml-5 xl:text-lg">{categoryLabel}</p>
                <Icon
                  name="chevron-right"
                  className="text-2xl text-brand-neutral-300 ml-auto lg:ml-3"
                />
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
